import { PageContainer } from '@/components'
import { CreateTask } from './create-task'

export interface DeleteTaskModal {
  id?: number
  visibel: boolean
}
const Create = () => (
  <PageContainer>
    <CreateTask />
  </PageContainer>
)

export default Create
